import omitBy from 'lodash/fp/omitBy';
import { Reducer } from 'react';
import { getType } from '@anm/helpers/saga/typesafe-actions';

import { discardLandingChanges, updateLanding, updateLandingViewType } from '../actions';
import { LandingsActions } from '../types';

import { initialLandingsState } from './index';
import { omitEmpty } from '@anm/helpers/video-landings/getLandingWithDefaults';

const updateLandingReducer: Reducer<typeof initialLandingsState, LandingsActions> = (
  state = initialLandingsState,
  action
) => {
  switch (action.type) {
    case getType(updateLanding): {
      const data = action.payload;

      const cleanedParams = omitBy(omitEmpty)(data.parameters);

      return {
        ...state,
        data: {
          ...state.data!,
          currentLanding: {
            ...state.data?.currentLanding!,
            ...data,
            parameters: cleanedParams
          }
        }
      };
    }

    case getType(discardLandingChanges): {
      return {
        ...state,
        data: {
          ...state.data!,
          currentLanding: state.data?.savedLanding!
        }
      };
    }

    case getType(updateLandingViewType): {
      const viewType = action.payload;

      return {
        ...state,
        viewType
      };
    }

    default:
      return state;
  }
};

export default updateLandingReducer;
